import { formatCurrency } from './get-price'

export function getFormatsDropdown (item) {
  if (!item.formats) {
    const dropdownWrapper = document.querySelector('.js-formats-dropdown')
    if (dropdownWrapper) {
      dropdownWrapper.style.display = 'none'
    }
    return ''
  }

  let formatType = 'name'
  if (window.theme.settings.bookDetailsSettings && window.theme.settings.bookDetailsSettings.format_name_type) {
    formatType = window.theme.settings.bookDetailsSettings.format_name_type
  }

  /* Check Other Formats Handle */
  let otherFormatHandles
  // get the custom value format handles & child_handles
  if (item.custom && item.custom.formats_array) {
    otherFormatHandles = item.custom.formats_array
  }

  // Get Format Name
  let formatName
  const matchingFormat = item.formats.find(format => format.isbn === item.isbn13)

  if (matchingFormat && matchingFormat.format) {
    if (matchingFormat.format.name) formatName = matchingFormat.format.name
    if (formatType === 'detail' && matchingFormat.detail) {
      formatName = matchingFormat.detail
    }
  }
  // Translate formatName
  let formatTranslatedKey
  if (formatName) formatTranslatedKey = formatName.toLowerCase().replaceAll(' ', '_')
  if (item.languages[formatTranslatedKey]) {
    formatName = item.languages[formatTranslatedKey]
  }

  let formatsDropdown = ''
  let formatsLabel = 'Formats'
  let formatLabel = 'Format'
  if (item.languages.formats) formatsLabel = item.languages.formats
  if (item.languages.format) formatLabel = item.languages.format

  if (otherFormatHandles && item.formats.some(format => otherFormatHandles[format.isbn])) {
    formatsDropdown =
    `<div class="dropdown__container" id="other-formats">
      <span>${formatsLabel}</span>
        <div class="dropdown__inner">
          <span tabindex="0">${formatName}</span>
          <ul>`
    /* Loop through other Formats */
    item.formats.forEach((otherFormat) => {
      let formatName
      if (otherFormat.format.name) formatName = otherFormat.format.name
      if (formatType === 'detail' && otherFormat.detail) {
        formatName = otherFormat.detail
      }

      // Translate formatName
      const otherFormatTranslatedKey = formatName.toLowerCase().replaceAll(' ', '_')
      if (item.languages[otherFormatTranslatedKey]) {
        formatName = item.languages[otherFormatTranslatedKey]
      }

      if (otherFormatHandles[otherFormat.isbn] && otherFormat.isbn) {
        formatsDropdown +=
        `<li data-isbn="${otherFormat.isbn}">
          <a href="/products/${otherFormatHandles[otherFormat.isbn]}">${formatName}</a>
        </li>`
      }
    })
    formatsDropdown += '</ul></div></div>'
  } else if (formatName) {
    formatsDropdown = `<span class="one-format">${formatLabel}: <span>${formatName}</span></span>`
  }

  return formatsDropdown
}

export function getFormatButtons (item) {
  if (!window.theme.settings.bookDetailsSettings || !window.theme.settings.bookDetailsSettings.format_location) {
    return ''
  }
  const formatLocation = window.theme.settings.bookDetailsSettings.format_location
  if (formatLocation !== 'below_title') {
    return ''
  }
  /* Check Other Formats Handle */
  let otherFormatHandles
  // get the custom value format handles & child_handles
  if (item.custom && item.custom.formats_array) {
    otherFormatHandles = item.custom.formats_array
  }

  let storeCurrency
  if (window.theme.settings.supaduCurrency.currency_iso) storeCurrency = window.theme.settings.supaduCurrency.currency_iso

  // get format field to use
  let formatType = 'name'
  if (window.theme.settings.bookDetailsSettings.format_name_type) {
    formatType = window.theme.settings.bookDetailsSettings.format_name_type
  }

  let formatButtons = '<div class="format-buttons-container">'

  item.formats.forEach(format => {
    let formatName
    if (format.format.name) formatName = format.format.name
    if (formatType === 'detail' && format.detail) {
      formatName = format.detail
    }
    // do not show prices from S3 if geolocation app is installed, as these prices will not be
    // converted into the current selected store currency
    let price = ''
    if (!window.theme.settings.geolocationEnabled) {
      const matchingLocale = format.prices.find(price => price.locale === storeCurrency)
      if (matchingLocale && matchingLocale.amount) {
        price = `<span class="format-button__price">${formatCurrency(matchingLocale.amount)}</span>`
        if (matchingLocale.discount) {
          price =
          `<span class="format-button__price discount">
            ${formatCurrency(matchingLocale.discount)}
            <strike class="format-button__price old">
              ${formatCurrency(matchingLocale.amount)}
            </strike>
          </span>`
        }
      }
    }
    // current format
    if (format.isbn === item.isbn13) {
      formatButtons +=
      `<a class="format-button current">
        <span class="format-button__format">${formatName}</span>
        ${price}
      </a>`
    } else if (otherFormatHandles && otherFormatHandles[format.isbn]) {
      formatButtons +=
      `<a href="/products/${otherFormatHandles[format.isbn]}" class="format-button">
        <span class="format-button__format">${formatName}</span>
        ${price}
      </a>`
    }
  })

  formatButtons += '</div>'

  return formatButtons
}

export function getCurrentFormatName (item) {
  if (!item.formats) return

  let formatName
  let formatType = 'name'
  if (window.theme.settings.bookDetailsSettings.format_name_type) formatType = window.theme.settings.bookDetailsSettings.format_name_type

  const currentFormat = item.formats.find(format => format.isbn === item.isbn13)
  if (currentFormat && currentFormat.format.name) formatName = currentFormat.format.name
  if (formatType === 'detail' && currentFormat.detail) formatName = currentFormat.detail
  if (formatName && item.languages[formatName.toLowerCase()]) formatName = item.languages[formatName.toLowerCase()]

  return formatName
}
